
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientTeamProfileResource,
  ClientTeamProfileUpdateRequest,
  ClientTeamSummary,
  TeamLogoResource,
} from '../models';
import {
    ClientTeamProfileResourceFromJSON,
    ClientTeamProfileResourceToJSON,
    ClientTeamProfileUpdateRequestFromJSON,
    ClientTeamProfileUpdateRequestToJSON,
    ClientTeamSummaryFromJSON,
    ClientTeamSummaryToJSON,
    TeamLogoResourceFromJSON,
    TeamLogoResourceToJSON,
} from '../models';

export interface GetClientTeamProfileRequest {
    clientTeamId: string;
}

export interface GetClientTeamSummaryRequest {
    clientTeamId: string;
}

export interface UpdateClientTeamLogoRequest {
    clientTeamId: string;
    file: Blob;
}

export interface UpdateClientTeamProfileRequest {
    clientTeamId: string;
    clientTeamProfileUpdateRequest: ClientTeamProfileUpdateRequest;
}

/**
 * 
 */
export class ClientTeamProfileApi extends runtime.BaseAPI {

    /**
     * Get a client team profile by its id
          */
    async getClientTeamProfileRaw(requestParameters: GetClientTeamProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientTeamProfileResource>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling getClientTeamProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientTeamProfileResource>({
            path: `/client-settings/api/client-teams/{clientTeamId}/profile`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientTeamProfileResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a client team profile by its id
          */
    async getClientTeamProfile(clientTeamId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientTeamProfileResource> {
        const response = await this.getClientTeamProfileRaw({ clientTeamId: clientTeamId }, initOverrides);
        return response._data;
    }

    /**
     * Get a client team summary by its id
          */
    async getClientTeamSummaryRaw(requestParameters: GetClientTeamSummaryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientTeamSummary>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling getClientTeamSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientTeamSummary>({
            path: `/client-settings/api/client-teams/{clientTeamId}`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientTeamSummaryFromJSON(response._data); }
        return response;
    }

    /**
     * Get a client team summary by its id
          */
    async getClientTeamSummary(clientTeamId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientTeamSummary> {
        const response = await this.getClientTeamSummaryRaw({ clientTeamId: clientTeamId }, initOverrides);
        return response._data;
    }

    /**
     * Upload a logo for a specific client team
          */
    async updateClientTeamLogoRaw(requestParameters: UpdateClientTeamLogoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<TeamLogoResource>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling updateClientTeamLogo().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling updateClientTeamLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<TeamLogoResource>({
            path: `/client-settings/api/client-teams/{clientTeamId}/logo`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=TeamLogoResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Upload a logo for a specific client team
          */
    async updateClientTeamLogo(clientTeamId: string, file: Blob, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<TeamLogoResource> {
        const response = await this.updateClientTeamLogoRaw({ clientTeamId: clientTeamId, file: file }, initOverrides);
        return response._data;
    }

    /**
     * Update a client team profile
          */
    async updateClientTeamProfileRaw(requestParameters: UpdateClientTeamProfileRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientTeamProfileResource>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling updateClientTeamProfile().'
            );
        }

        if (requestParameters['clientTeamProfileUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientTeamProfileUpdateRequest',
                'Required parameter "clientTeamProfileUpdateRequest" was null or undefined when calling updateClientTeamProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientTeamProfileResource>({
            path: `/client-settings/api/client-teams/{clientTeamId}/profile`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientTeamProfileUpdateRequestToJSON(requestParameters['clientTeamProfileUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientTeamProfileResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update a client team profile
          */
    async updateClientTeamProfile(clientTeamId: string, clientTeamProfileUpdateRequest: ClientTeamProfileUpdateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientTeamProfileResource> {
        const response = await this.updateClientTeamProfileRaw({ clientTeamId: clientTeamId, clientTeamProfileUpdateRequest: clientTeamProfileUpdateRequest }, initOverrides);
        return response._data;
    }

}
